/**
 * Single source of truth for classifying a pathname against the partner
 * white-label surfaces. Both the footer gate (which Sukuto chrome to hide) and
 * the global origin-reset gate (when to drop a stale partner cookie) must agree
 * on what counts as a partner route vs. a global one, so the classification
 * lives here instead of being duplicated per consumer.
 *
 * Pathname-only (no query/hash). Safe on the server and the client.
 */

/** True for the partner storefront route group: /partner/<slug>/... */
export const isPartnerPath = (pathname) => /^\/partner(?:\/|$)/.test(pathname || "");

/**
 * Shared routes that belong to the partner journey WHEN reached from a
 * storefront: the checkout funnel (/cart, /booking) and the user account pages
 * (/user/...). These live outside /partner/<slug>/ but render partner branding
 * via JourneyChrome while the booking-origin cookie is set.
 */
export const isPartnerJourneyPath = (pathname) =>
  /^\/(?:cart|booking)\/?$/.test(pathname || "") ||
  /^\/user(?:\/|$)/.test(pathname || "");

/**
 * True only for genuinely global pages — i.e. neither a partner storefront nor
 * a branded journey route. A visit to one of these is the explicit signal that
 * the user has left any partner storefront, so the booking-origin cookie should
 * be dropped (so partner branding/attribution can't follow them back into the
 * shared cart/booking/account routes).
 */
export const isGlobalPath = (pathname) =>
  !isPartnerPath(pathname) && !isPartnerJourneyPath(pathname);
